export default __webpack_public_path__ + "i18n/ro.e117e857688146a4153ad17dc21cd18d.json";